import { Link } from "react-router-dom";
import BgImage from "../images/acfan.jpg";
import HeroSection from "../components/HeroSection";
import ImgA from "../images/PRODUCT1-scaled.webp";

import AllProducts from "../images/all products.png";
import Airconditioners from "../images/air conditioners.png";
import AirWashers from "../images/air washers.png";
import ColdRoom from "../images/cold room.png";
import AirOthers from "../images/air others.png";
import { useState, useEffect } from "react";
import { allapiAction } from "../Redux/common/action";
import { URL } from "../Redux/common/url";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const lkData = [
  {
    title: "OUR PRODUCTS",
    description:
      "At SOLAR CLUB BHARAT, we provide expert, end-to-end cooling solutions designed for comfort, efficiency, and sustainability. Our team combines technical experience with a customer-first approach to help you find the ideal cooling system for your industrial, commercial, or institutional space.",
  },
];

const loData = [
  {
    img: ImgA,
    title: "Desert Window Tower or Personal",
    button: "Detailes",
    button1: "Enquiry",
  },
];

const lpData = [
  {
    img: ImgA,
    title: "Dragon Ball Z: Cooler for a character.",
    button: "Detailes",
    button1: "Enquiry",
  },
];

const refData = [
  {
    img: ImgA,
    title: "Refrigeration for industrial use.",
    button: "Detailes",
    button1: "Enquiry",
  },
];

const humData = [
  {
    img: ImgA,
    title: "Humidifiers for better air quality.",
    button: "Detailes",
    button1: "Enquiry",
  },
];

function Services() {
  // // ✅ Hooks must be inside the function component
  // const [currentColorIndex, setCurrentColorIndex] = useState(0);

  // const colors = ["red", "blue", "green", "orange", "purple"];

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentColorIndex(prevIndex => (prevIndex + 1) % colors.length);
  //   }, 2000);

  //   return () => clearInterval(interval); // Cleanup on unmount
  // }, []);

  // const getColor = (offset) => colors[(currentColorIndex + offset) % colors.length];

  // // Combine all products into one array for "All Services"
  // const allProducts = [...loData, ...lpData, ...refData, ...humData];

  // ✅ Hooks must be inside the function component
  const [currentColorIndex, setCurrentColorIndex] = useState(0);

  const colors = ["red", "blue", "green", "orange", "purple"];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 2000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const getColor = (offset) =>
    colors[(currentColorIndex + offset) % colors.length];

  // Combine all products into one array for "All Services"
  const allProducts = [...loData, ...lpData, ...refData, ...humData];
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [valuevendor, setValuevendor] = useState("");
  const [valuesetUserDeatils, setUserDeatils] = useState({});
  const router = useNavigate();
  const all_categories_List = useSelector((state) =>
    state?.allapi?.all_categories_List
      ? state?.allapi?.all_categories_List
      : [],
  );
  const get_home_all_pro = useSelector((state) =>
    state?.allapi?.get_home_all_pro ? state?.allapi?.get_home_all_pro : {},
  );
  const recentrecentProduct = get_home_all_pro?.Product
    ? get_home_all_pro?.Product
    : [];

  console.log(get_home_all_pro);
  console.log(recentrecentProduct);

  useEffect(() => {
    dispatch(allapiAction.getCategory({}));
    dispatch(allapiAction.gethomePro({}));
    return () => {};
  }, []);
  const [activeCate, setactiveCate] = useState("All");
  const hendleToChange = (e, id) => {
    setactiveCate(e);
    dispatch(allapiAction.gethomePro({ cateId: id }));
  };
  const hendleToChange1 = (e, id) => {
    setactiveCate(e);
    dispatch(allapiAction.gethomePro({}));
  };

  return (
    <div className="container-fluid px-0 pt-5">
      <div
        style={{
          backgroundImage: `url(${BgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          minHeight: "150px", // mobile friendly chhota height
          paddingTop: "30px", // desktop: 50px, mobile: 30px
          paddingBottom: "30px",
          position: "relative",
          color: "white",
        }}
        className="d-flex align-items-center"
      >
        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1,
          }}
          className="overlay"
        ></div>

        {/* Content */}
        <div
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: "1200px",
            margin: "0 auto",
            textAlign: "center",
            padding: "0 15px",
          }}
          className="p-3"
        >
          <h1
            className="fw-bold"
            style={{ fontSize: "clamp(1.2rem, 5vw, 2rem)", fontWeight: "700" }}
          >
            Services
          </h1>
          <p
            className="lead"
            style={{
              fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
              margin: "0.5rem 0 1rem 0",
            }}
          >
            Explore our range of smart solar energy and maintenance services
            designed to power your industrial and commercial spaces efficiently
            year-round.{" "}
          </p>

          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol
              style={{
                listStyle: "none",
                display: "flex",
                justifyContent: "center",
                padding: 0,
                margin: 0,
              }}
            >
              <li style={{ marginRight: "5px" }}>
                <Link to="/" style={{ color: "white", textDecoration: "none" }}>
                  Home
                </Link>
                <span style={{ margin: "0 5px" }}>/</span>
              </li>
              <li style={{ color: "white" }}>Services</li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container-fluid">
        {lkData.map((lk, index) => (
          <div className="row my-0 d-flex align-items-center mt-4" key={index}>
            <div>
              <h1 className="card-title fw-bold">Our Services</h1>
              <p className="card-text mt-2">
                Providing end-to-end Solar Energy Solutions across Rajasthan,
                including rooftop solar systems, on-grid & off-grid solar
                plants, hybrid solar solutions, solar water pumps, solar street
                lights, solar panels, inverters, batteries, and EV charging
                systems. Expert consultation, design, installation, and
                maintenance services for residential, commercial, and industrial
                projects.
              </p>
              <hr />
            </div>
          </div>
        ))}

        <div className="container-fulid my-3">
          <div className="overflow-auto">
            <ul className="nav flex-nowrap" id="productTab" role="tablist">
              <li className="nav-item text-center" role="presentation">
                <button
                  className="nav-link text-shadow fw-bold"
                  // id="ac-tab"
                  // data-bs-toggle="tab"
                  // data-bs-target="#airConditioners"
                  // type="button"
                  // role="tab"
                  // aria-controls="airConditioners"
                  // aria-selected="false"
                  onClick={() => {
                    hendleToChange1("All", "1");
                  }}
                >
                  <div>
                    <img
                      className="product-tab-logo"
                      src={AllProducts}
                      alt=""
                    />
                  </div>
                  <div className="text-nowrap text-danger"> All Services</div>
                </button>
              </li>
              {/* All Services Tab */}
              {all_categories_List &&
                all_categories_List?.map((data, i) => {
                  return (
                    <li className="nav-item text-center" role="presentation">
                      <button
                        className="nav-link text-shadow fw-bold"
                        id={data?.slug}
                        data-categoryslug={data?.slug}
                        data-toggle="tab"
                        href={`#${data?.slug}`}
                        role="tab"
                        aria-controls={data?.slug}
                        aria-selected="false"
                        onClick={() => {
                          hendleToChange(data?.name, data?._id);
                        }}
                      >
                        <div>
                          <img
                            className="product-tab-logo"
                            src={URL?.API_BASE_URL + data?.image}
                            alt="category"
                          />
                        </div>
                        <div className="text-nowrap text-danger">
                          {" "}
                          {data?.name}
                        </div>
                      </button>
                    </li>
                  );
                })}
              {/* <li className="nav-item text-center" role="presentation">
                <button
                  className="nav-link text-shadow fw-bold"
                  id="ac-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#airConditioners"
                  type="button"
                  role="tab"
                  aria-controls="airConditioners"
                  aria-selected="false"
                >
                  <div>
                    <img className='product-tab-logo' src={Airconditioners} alt="" />
                  </div>
                </button>
              </li>

          
              <li className="nav-item text-center" role="presentation">
                <button
                  className="nav-link text-shadow fw-bold"
                  id="aw-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#airWashers"
                  type="button"
                  role="tab"
                  aria-controls="airWashers"
                  aria-selected="false"
                >
                <div>
                    <img className='product-tab-logo' src={AirWashers} alt="" />
                  </div>
                </button>
              </li>

          
              <li className="nav-item text-center" role="presentation">
                <button
                  className="nav-link text-shadow fw-bold"
                  id="ref-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#refrigerators"
                  type="button"
                  role="tab"
                  aria-controls="refrigerators"
                  aria-selected="false"
                >
                <div>
                    <img className='product-tab-logo' src={ColdRoom} alt="" />
                  </div>
                </button>
              </li>

              <li className="nav-item text-center" role="presentation">
                <button
                  className="nav-link text-shadow fw-bold"
                  id="hum-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#humidifiers"
                  type="button"
                  role="tab"
                  aria-controls="humidifiers"
                  aria-selected="false"
                >
                  <div>
                    <img className='product-tab-logo' src={AirOthers} alt="" />
                  </div>
                </button>
              </li> */}
            </ul>
          </div>

          <div className="tab-content py-4" id="productTabContent">
            {/* All Services */}
            <div
              className="tab-pane fade show active"
              id="allProducts"
              role="tabpanel"
              aria-labelledby="all-tab"
            >
              <div className="row">
                {recentrecentProduct &&
                  recentrecentProduct?.map((data, i) => {
                    const recivedPr =
                      (data?.recivedAmount / data?.afterdiscountprice) * 100;
                    return (
                      <div className="col-12 col-sm-6 col-md-3 mb-3">
                        <div className="card h-100 rounded-4 overflow-hidden bg-light bg-opacity-50 p-3 text-center">
                          <a
                            href={"productdetail/" + data?.pro_sulg}
                            class="d-block card-img-wrap ratio-img"
                          >
                            <img
                              src={URL?.API_BASE_URL + data?.featureImage}
                              className="card-img-topmk w-100 py-0 rounded-top-4 product-img-out"
                              alt={data.title}
                            />
                            <h5 className="card-title fw-bold text-dark mt-2">
                              {data?.title}
                            </h5>
                          </a>
                          {/* <div className='d-flex justify-content-between'>
                        <button variant="danger" className="btn btn-danger mt-2">
                          {item.button}
                        </button>
                        <button variant="danger" className="btn btn-danger mt-2">
                          {item.button1}
                        </button>
                      </div> */}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

            {/* <div className="tab-pane fade " id="airConditioners" role="tabpanel" aria-labelledby="ac-tab">
              <div className="row">
                {loData.map((lo, index) => (
                  <div className="col-12 col-sm-6 col-md-3 mb-3" key={index}>
                    <div className="card h-100 rounded-4 overflow-hidden bg-light bg-opacity-50 p-3 text-center">
                      <img src={lo.img} className="card-img-topmk py-0 rounded-top-4 product-img-out" alt={lo.title} />
                      <h5 className="card-title fw-bold text-dark mt-2">{lo.title}</h5>
                      <div className='d-flex justify-content-between'>
                        <button variant="danger" className="btn btn-danger mt-2">
                          {lo.button}
                        </button>
                        <button variant="danger" className="btn btn-danger mt-2">
                          {lo.button1}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            {/* <div className="tab-pane fade" id="airWashers" role="tabpanel" aria-labelledby="aw-tab">
              <div className="row">
                {lpData.map((lp, index) => (
                  <div className="col-12 col-sm-6 col-md-3 mb-3" key={index}>
                    <div className="card h-100 rounded-4 overflow-hidden bg-light bg-opacity-50 p-3 text-center">
                      <img src={lp.img} className="card-img-topmk py-0 rounded-top-4 product-img-out" alt={lp.title} />
                      <h5 className="card-title fw-bold text-dark mt-2">{lp.title}</h5>
                      <div className='d-flex justify-content-between'>
                        <button variant="danger" className="btn btn-danger mt-2">
                          {lp.button}
                        </button>
                        <button variant="danger" className="btn btn-danger mt-2">
                          {lp.button1}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            {/* <div className="tab-pane fade" id="refrigerators" role="tabpanel" aria-labelledby="ref-tab">
              <div className="row">
                {refData.map((ref, index) => (
                  <div className="col-12 col-sm-6 col-md-3 mb-3" key={index}>
                    <div className="card h-100 rounded-4 overflow-hidden bg-light bg-opacity-50 p-3 text-center">
                      <img src={ref.img} className="card-img-topmk py-0 rounded-top-4 product-img-out" alt={ref.title} />
                      <h5 className="card-title fw-bold text-dark mt-2">{ref.title}</h5>

                      <div className='d-flex justify-content-between'>
                        <button variant="danger" className="btn btn-danger mt-2">
                          {ref.button}
                        </button>

                        <button variant="danger" className="btn btn-danger mt-2">
                          {ref.button1}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            {/* <div className="tab-pane fade" id="humidifiers" role="tabpanel" aria-labelledby="hum-tab">
              <div className="row">
                {humData.map((hum, index) => (
                  <div className="col-12 col-sm-6 col-md-3 mb-3" key={index}>
                    <div className="card h-100 rounded-4 overflow-hidden bg-light bg-opacity-50 p-3 text-center">
                      <img src={hum.img} className="card-img-topmk py-0 rounded-top-4 product-img-out" alt={hum.title} />
                      <h5 className="card-title fw-bold text-dark mt-2">{hum.title}</h5>

                      <div className='d-flex justify-content-between'>
                        <button variant="danger" className="btn btn-danger mt-2">
                          {hum.button}
                        </button>
                        <button variant="danger" className="btn btn-danger mt-2">
                          {hum.button1}
                        </button>
                      </div>

                    </div>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <HeroSection />
    </div>
  );
}

export default Services;
